<template>
  <div>
    <div class="input-group">
      <input
        type="text"
        ref="text"
        class="form-control"
        v-model="value.Name"
        @focus="onFocus"
        :placeholder="getPlaceholder"
        v-readonly
        v-bind="$attrs"
      >
      <span
        class="add-on"
        v-if="!$attrs.disabled"
      >
        <img
          v-if="!value.Name"
          :src="`${$root.cdnUrl}assets/icon-arrow-down-gray.svg`"
        >
        <img
          v-else
          :src="`${$root.cdnUrl}assets/icon-close-gray.svg`"
          @click="clear"
        >
      </span>
    </div>
    <Modal
      :show="showModal"
      @close="close"
      class="modal-category-select"
    >
      <template slot="modal-title">
        <div class="modal-title">
          Kategori Seçimi
        </div>
      </template>
      <template slot="modal-body">
        <div
          class="nodes"
          id="nodes"
        >
          <node
            v-for="(items, k) in categories"
            :key="k"
            :items="items"
            @onSelect="onSelect"
            @onBack="onBack"
          />
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal';
import Node from './Node';
export default {
  name: 'CategoryTree',
  components: { Node, Modal },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      showModal: false,
      categories: [],
    };
  },
  computed: {
    getOptions () {
      return [{
        Nodes: this.options,
      }];
    },
    getPlaceholder () {
      return this.$attrs.placeholder || 'Ekleyeceğiniz ürünün kategorisiniz seçiniz';
    },
  },
  methods: {
    async setScrollPosition () {
      await this.$nextTick();
      const nodes = document.getElementById('nodes');
      nodes.scrollLeft = nodes.scrollWidth;
    },
    async onSelect (category) {
      if (category.Nodes) {
        this.categories.push(category);
        await this.setScrollPosition();
      } else {
        this.$emit('input', category);
        this.$emit('onSelect', category);
        this.close();
      }
    },
    async onBack () {
      this.categories.splice(-1);
      await this.setScrollPosition();
    },
    async onFocus () {
      this.showModal = true;
      await this.$nextTick();
      this.$refs.text.blur();
      this.$emit('toggleModal', this.showModal);
    },
    close () {
      this.showModal = false;
      this.$emit('toggleModal', this.showModal);
    },
    clear () {
      this.$emit('input', {});
    },
  },
  created () {
    this.categories = this.getOptions;
  },
  watch: {
    options () {
      this.categories = this.getOptions;
    },
  },
};
</script>

<style lang="scss" scoped>
  .nodes {
    margin: 0 -20px;
    min-height: 400px;
    display: flex;

    overflow: hidden;
  }
  .modal-category-select {
    ::v-deep .modal {
      border-radius: 15px 15px 0 0;

      .modal-body {
        min-height: 400px;
      }

      @media screen and (max-height: 550px) {
        top: initial;
        bottom: 0;
        .modal-body{
          margin: 0 -20px;
          min-height: 1px;
          .nodes {
            margin: 0;
            min-height: 1px;
            .node {
              max-height: 200px;
            }
          }
        }
      }
    }
  }
</style>
